<template>
    <div class="card_container" @click="goToPath" :class="{ 'pop-animate': isPopping }">
        <div class="activity_name">{{ $t(`activityName.${props.itemData.name}`) }}</div>
        <van-row class="bottom_part" gutter="15">
            <van-col span="4" class="left_col">
                <div class="icon_wrapper">
                    <!-- <img :src="props.itemData.icon" alt="" :class="{ iconshake: unclaimed_count > 0 }" /> -->
                    <img :src="props.itemData.activity_icon" alt="" class="iconshake" />
                    <div v-if="unclaimed_count > 0" class="redPoint">
                        {{ unclaimed_count }}
                    </div>
                </div>
            </van-col>
            <van-col span="20" class="right_col">
                <img :src="props.itemData.image" alt="" />
            </van-col>
        </van-row>
    </div>
</template>


<script setup lang="ts">
import { playClickSound } from '@/utils/media';
import { goToRedirectPath, PromotionItem } from '@/view/promotion/supporrtScript';
import { ref, defineProps, defineEmits, computed, PropType } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter()
const props = defineProps({
    itemData: {
         type: Object as PropType<PromotionItem>,
        default: () => ({
            name: '',
            unclaimed_count: 0,
            image: '',
            icon: ''
        }),
        required: true
    },
    unClaimedCount: {
        type: Number,
        default: () => 0
    }
})
const isPopping = ref(false)

const unclaimed_count = computed(() => props.unClaimedCount)
const emits = defineEmits(["openAgentPopup", "openRedEnvelop", "goToHome", "openPWA"])

const goToPath = () => {
    goToRedirectPath(isPopping, props.itemData, router, emits, playClickSound)
}

</script>
<style scoped>
@keyframes periodicShake {
    0% {
        transform: rotate(0deg);
    }

    5% {
        transform: rotate(-11deg);
    }

    10% {
        transform: rotate(11deg);
    }

    15% {
        transform: rotate(-11deg);
    }

    20% {
        transform: rotate(11deg);
    }

    25% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(0deg);
    }
}

.iconshake {
    animation: periodicShake 3s ease-in-out infinite;
}

.card_container {
    border-radius: 5px;
    overflow: hidden;
    margin: 10px 15px;
}

.activity_name {
    color: #ffffffd9;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 5px;
}

.bottom_part {
    display: flex;
    align-items: stretch;
    /* height: 6rem; */
}

.left_col {
    background: linear-gradient(135deg, #FCD7A1 0%, #D17836 100%);
    display: flex;
    justify-content: center;
    /* height: 6rem; */
    border-radius: 0.55rem;
    align-items: center;
    padding-right: 0 !important;
}

/* .left_col .icon_wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 47px;
    height: 47px;
    background: #27190d9e;
    border-radius: 50%;
    border:1px solid #ffffffc2; 
   box-shadow: 0 0 8px rgba(209, 120, 54, 0.6);
} */

.left_col .icon_wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    height: 55%;
    background: #482a13;
    /* background: radial-gradient(circle at 30% 30%, #fff5dc, #d17836); */
    border-radius: 50%;
    border: 2px solid #ffffffc2;
    /* box-shadow:
        inset -2px -2px 5px rgba(255, 255, 255, 0.3),
        inset 2px 2px 5px rgba(0, 0, 0, 0.2),
        0 4px 6px rgba(0, 0, 0, 0.4); */
    transition: transform 0.2s ease;
}

.left_col .icon_wrapper:hover {
    transform: scale(1.05);
}

.left_col img {
    width: 75%;
    display: block;
    border-radius: 5px;
}

.redPoint {
    position: absolute;
    top: -5px;
    right: 0px;
    width: 18px;
    height: 18px;
    background: radial-gradient(circle at 30% 30%, #ff5c5c, #c90000);
    border-radius: 50%;
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    line-height: 18px;
    text-align: center;
    box-shadow:
        inset -1px -1px 3px rgba(255, 255, 255, 0.4),
        inset 1px 1px 2px rgba(0, 0, 0, 0.2),
        0 2px 4px rgba(0, 0, 0, 0.5);
    z-index: 1;
}


.right_col img {
    width: 100%;
    border-radius: 0.45rem;
    /* height: 6rem; */
}
</style>